import { Container } from '@pixi/react';
import { Resource, Texture } from 'pixi.js';
import { JackPotSceneNumberItemContent } from './jackPotSceneNumberItemContent';

export const JackPotSceneNumberItemWrapper: React.FC<{ winIcon: any, jackPotItemEnum: any[] }> = ({
  winIcon,
  jackPotItemEnum,
}) => {

  return (
    <Container {...({ name: 'JackPotCardsSectionContainer' } as any)}>
      {jackPotItemEnum.map((item) => {
        return (
          <JackPotSceneNumberItemContent
            x={item.x}
            y={item.y}
            id={item.id}
            key={item.id}
            type={item.type}
            winIcon={winIcon}
            containerName={item.name}
            image={item.image as Texture<Resource>}
          />
        );
      })}
    </Container>
  );
}
